import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  horizontalWrapper: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  content: {
    overflow: 'hidden',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  sidebar: {
    width: '260px',
    minWidth: '260px',
    borderRight: `1px solid ${theme.palette.divider}`,
    overflow: 'auto',
  },
}))
